/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export enum ProactiveChatNames {
    DateRange = 'Date Range',
    FromSpecificPage = 'From Specific Page',
    PageVisits = 'Page Visits',
    SpecificLocation = 'Specific Location',
    SpecificPage = 'Specific Page',
    WaitOnTime = 'Wait On Time'
}
